export const DASHBOARD = '/dashboard';
export const DASHBOARD_DEVICE_ALERTS = DASHBOARD + '/device-alerts';
export const DASHBOARD_OUTDOOR_CONDITIONS = DASHBOARD + '/outdoor-conditions';
export const DASHBOARD_SMOKE_READINESS = DASHBOARD + '/smoke-readiness';
export const DASHBOARD_SMOKE_SITE_DETAIL = DASHBOARD_SMOKE_READINESS + '/sites';
export const DASHBOARD_ZONES_NEEDING_ACTION = DASHBOARD + '/zones-needing-action';
export const DASHBOARD_ZONE_DETAIL = DASHBOARD_ZONES_NEEDING_ACTION + '/zones';
export const DASHBOARD_CLOSING_THE_LOOP = DASHBOARD + '/closing-the-loop';
export const CUSTOMERS = '/customers';
export const DEVICES = '/devices';
export const SETTINGS = '/settings';
export const MYORG = '/myorg';
export const PROFILE = '/profile';
export const HELP = '/help';
export const SITE = '/site';
export const LOGIN = '/login';
export const PAGE_404 = '/404';
export const PAGE_500 = '/500';
export const REGISTER = '/register';
export const FORGOT_PASSWORD = '/forgot-password';
export const RESET_PASSWORD = '/reset-password';
export const ADD_ORG = '/add-organization';
export const DEVICE_SITE = '/device-site';
export const CUSTOMER_SITE = '/customer-site';
export const DEVICE_COMMAND = '/device-command';
export const CUSTOMER_COMMAND = '/customer-command';
export const ADD_CUSTOMER = CUSTOMERS + ADD_ORG;
export const HOME = '/';
export const INVITED_USER = '/invited-user';
export const MFA_SETUP = '/mfa/setup';
export const MFA_VERIFY = '/mfa/verify';
export const STYLEGUIDE = '/styleguide';
export const SINGLEDEVICE = '/single-device';
export const SINGLEDEVICEROUTE = DEVICES + SINGLEDEVICE;
export const MANAGE_SITE = SITE;
export const MANAGE_SITE_FROM_DEVICE = DEVICES + DEVICE_SITE;
export const MANAGE_COMMANDS_FROM_DEVICE = DEVICES + DEVICE_SITE + DEVICE_COMMAND;
export const MANAGE_SITE_FROM_CUSTOMERS = CUSTOMERS + CUSTOMER_SITE;
export const MANAGE_COMMANDS_FROM_CUSTOMERS = CUSTOMERS + CUSTOMER_SITE + CUSTOMER_COMMAND;
export const SERVICER = '/servicers';
export const PERFORMANCE = '/performance';
export const BAR = '/bar';
export const DASHBOARD_PERFORMANCE = DASHBOARD + PERFORMANCE;
export const DASHBOARD_BAR_PERFORMANCE = DASHBOARD + PERFORMANCE + BAR;
export const RANGE = '/range';
export const DASHBOARD_PERFORMANCE_RANGE = DASHBOARD_PERFORMANCE + RANGE;
export const FIRMWARES = '/firmwares';
export const GET_ALL_DEVICE = 'get-all-device';
export const USERS = '/user';
export const MANAGE_USERS = CUSTOMERS + USERS;
export const CUSTOM_RANGE = '/custom-range';
export const MANAGE_MFA = '/manage-mfa';
export const FORGOT_MFA = '/forgot-mfa';
export const FORGOT_MFA_EMAIL = '/forgot-mfa-email';
export const SPATIALVIEW = '/spatialview';
export const SPATIALVIEWER ='/spatialviewer';
export const MANAGE_SPATIALVIEWER =SPATIALVIEW + SPATIALVIEWER;
export const DEVICE_SPATIALVIEW = '/device-spatialview';
export const MANAGE_SPATIALVIEW_FROM_DEVICE = DEVICES + DEVICE_SPATIALVIEW;
export const DEVICE_SPATIALVIEWER = '/device-spatialviewer';
export const MANAGE_SPATIALVIEWER_FROM_DEVICE = DEVICES + DEVICE_SPATIALVIEW + DEVICE_SPATIALVIEWER;









export const OPERATIONS = '/operations';
// export const MANAGE_OPERATIONS = SPATIALVIEW  + OPERATIONS;
export const DEVICE_OPERATIONS = '/device-operations';
// export const MANAGE_OPERATIONS_FROM_DEVICE = DEVICES + DEVICE_SPATIALVIEW + DEVICE_OPERATIONS;
export const MANAGE_OPERATIONS = MANAGE_SPATIALVIEWER + OPERATIONS;
export const MANAGE_OPERATIONS_FROM_DEVICE = MANAGE_SPATIALVIEWER_FROM_DEVICE + DEVICE_OPERATIONS;